
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.11 16H1a1 1 0 01-1-1V4.383a1 1 0 011-1h4.4a8.115 8.115 0 00-.269.285 7.85 7.85 0 00-1.169 1.715H2V14h10.112V7.644l2-1.2V15a1 1 0 01-1.002 1zM5.5 9.9a1 1 0 01-1-1 6.461 6.461 0 015.72-6.416v-2c0-.294.136-.484.347-.484a.478.478 0 01.233.07l4.966 2.985a.486.486 0 01.234.391.488.488 0 01-.228.4L10.8 6.826a.479.479 0 01-.236.07.3.3 0 01-.25-.128.6.6 0 01-.1-.356V4.5A4.433 4.433 0 006.5 8.9a1 1 0 01-1 1z","fill":"#222"}})])
          )
        }
      }
    